module.exports = __webpack_public_path__ + "static/media/react.90552fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/frontend/react.png
// module id = 1533
// module chunks = 0